import { useEffect, useState } from "react";
import { useAuth } from "@/hooks/useAuth";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";
import { useNavigate } from "react-router-dom";

export function useIpWhitelist() {
  const { profile, user } = useAuth();
  const [isChecking, setIsChecking] = useState(true);
  const [isBlocked, setIsBlocked] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const checkIpAccess = async () => {
      if (!profile?.organization_id || !user) {
        setIsChecking(false);
        return;
      }

      try {
        const { data, error } = await supabase.functions.invoke("check-ip-access", {
          body: {
            organization_id: profile.organization_id,
            user_id: user.id,
          },
        });

        if (error) {
          console.error("IP check error:", error);
          setIsChecking(false);
          return;
        }

        if (!data.allowed) {
          setIsBlocked(true);
          toast.error(data.message || "Access denied from your IP address");
          await supabase.auth.signOut();
          navigate("/login");
        }
      } catch (error) {
        console.error("IP whitelist check failed:", error);
      } finally {
        setIsChecking(false);
      }
    };

    checkIpAccess();
  }, [profile?.organization_id, user, navigate]);

  return { isChecking, isBlocked };
}
